/* eslint-disable import/first */
import Vue from 'vue'
import App from './App'
import * as Sentry from '@sentry/browser'
import router from './router'

Sentry.init({
  dsn: 'https://ed174cce7a4b44868b289f9c1814b298@sentry.io/1420764',
  environment: process.env.NODE_ENV,
  beforeSend: (event) => {
    // drop events from env NOT listed here
    if (['production', 'staging'].indexOf(process.env.NODE_ENV) === -1) {
      return null
    }

    return event
  }
})

// Axios with api config
import api from './lib/api'
Vue.prototype.axios = api

// Bootstrap
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.use(BootstrapVue)

// Filters
import Vue2Filters from 'vue2-filters'
Vue.use(Vue2Filters)

// Font Awesome
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
Vue.component('font-awesome-icon', FontAwesomeIcon)
import { library } from '@fortawesome/fontawesome-svg-core'
import { faFilePdf, faTrashAlt, faEdit, faArrowsAltV, faCheckCircle, faSpinner } from '@fortawesome/free-solid-svg-icons'
library.add(faFilePdf, faTrashAlt, faEdit, faArrowsAltV, faCheckCircle, faSpinner)

const moment = require('moment')
require('moment/locale/de')

Vue.use(require('vue-moment'), {
  moment
})

Vue.prototype.$apiConfig = process.env.API
Vue.prototype.$eventHub = new Vue({router})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  config: process.env,
  template: '<App/>',
  components: { App }
})

router.beforeEach((to, from, next) => {
  // hide all errors before navigating to a new page
  router.app.$eventHub.$emit('alertHide')
  next()
})



//////////////////
// WEBPACK FOOTER
// ./src/main.js
// module id = 794
// module chunks = 1